module.exports = __webpack_public_path__ + "static/media/checkmark.ad8d59de.svg";